import req from '@sportninja/common/api/request'

export interface Videographer {
  id: string
  user_id: string | null
  invitation_id: string | null
  name_first: string
  name_last: string
  email?: string
  avatar_url: string | null
  user_exists: boolean
}

/**
 * Fetch videographers for a specific game roster
 */
export const fetchVideographers = async (
  gameId: string,
  rosterId: string
): Promise<Videographer[]> => {
  if (!gameId || !rosterId) {
    return []
  }
  const { data } = await req(`/games/${gameId}/rosters/${rosterId}/users`)
  return (data || []).filter(
    (u: { role: string }) => u.role === 'videographer'
  ) as Videographer[]
}

/**
 * Add videographer to a game roster
 */
export const addVideographer = async (
  gameId: string,
  rosterId: string,
  params: { email: string; name_first?: string; name_last?: string }
): Promise<{
  user_exists: boolean
  user_uid?: string
  invitation_uid?: string
}> => {
  const response = await req(`/games/${gameId}/rosters/${rosterId}/users`, {
    method: 'POST',
    body: JSON.stringify({
      email: params.email,
      role: 'videographer',
      name_first: params.name_first,
      name_last: params.name_last,
    }),
  })
  return response
}

/**
 * Remove videographer from a game roster (for accepted users)
 */
export const removeVideographer = async (
  gameId: string,
  rosterId: string,
  userId: string
): Promise<void> => {
  await req(`/games/${gameId}/rosters/${rosterId}/users/${userId}`, {
    method: 'DELETE',
    query: { role: 'videographer' },
  })
}

/**
 * Remove videographer invitation from a game roster (for pending invites)
 */
export const removeVideographerInvitation = async (
  gameId: string,
  rosterId: string,
  invitationId: string
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/users/invitation/${invitationId}`,
    {
      method: 'DELETE',
    }
  )
}

/**
 * Resend videographer invitation
 */
export const resendVideographerInvitation = async (
  invitationId: string
): Promise<void> => {
  await req(`/invitations/${invitationId}/resend`)
}
